import codes from './codes.json';
import en from './locales/en.json';
import jp from './locales/jp.json';
import dk from './locales/dk.json';
import nl from './locales/nl.json';
import br from './locales/br.json';
export default { codes, en, jp, dk, nl, br };
